import { Policy } from "../objects/policy";

export class LienHolderService {

    saveLienHolderApi = "";

    constructor (){
        var baseApi = process.env.REACT_APP_BASE_API_URL;
        var api = process.env.REACT_APP_API_QUOTE_ISSUE ?? "";
        var saveLienHolderEndpoint = process.env.REACT_APP_API_QUOTE_SAVE_LIENHOLDERS ?? "";
        this.saveLienHolderApi = baseApi + saveLienHolderEndpoint;
    }

    public async saveLienHolders(quote: Policy){
        var jsonRequest = JSON.stringify(quote);
        
        var result = await fetch(this.saveLienHolderApi,
            {
                mode: "cors",
                method: "POST",
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json",
                    "pace-api-key": (process.env.REACT_APP_API_KEY ?? "")
                },
                body: jsonRequest
            });

        if(result.ok){
            return {
                ok: true,
                data: await result.json()
            }
        } else {
            return {
                ok: false,
                error: await result.json()
            }
        }
    }
}